import styled from "styled-components/macro";
import { Text } from "../../../../components";

export default styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.dark,
}));
